import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import WrappedTabs from '../../common/WrappedTabs'
import { productModelsUploadInstructions } from '../../../utils/fixedUrls'
import { InformationIcon } from '../../../icons'
import { loadAdminProductTypes, loadProductModelsFilterOptions } from '../../../actions/productModels'
import Models from './Models'
import ModelImages from './ModelImages'
import Variants from './Variants'
import ProductTypes from './ProductTypes'

const productModelsPages = [
  {
    key: 0,
    title: 'product_models_context.model_variants',
    content: <Variants />,
  },
  {
    key: 1,
    title: 'monitoring.models',
    content: <Models />,
  },
  {
    key: 2,
    title: 'product_models_context.model_images',
    content: <ModelImages />,
  },
  {
    key: 3,
    title: 'product_models_context.product_types',
    content: <ProductTypes />,
  },
]

const ProductModels = (props) => {
  const { t } = useTranslation()
  const [selectedPage, setSelectedPage] = useState(productModelsPages[0])

  const handleTabClick = (index) => {
    const page = productModelsPages.find(({ key }) => key === index)
    setSelectedPage(page)
  }

  useEffect(() => {
    if (Object.keys(props.filters).length === 0) {
      props.actions.loadProductModelsFilterOptions()
    }

    if (props.adminProductTypes.length === 0) {
      props.actions.loadAdminProductTypes()
    }
  }, [props.actions])

  return (
    <>
      <div className="information-box-text product-models-information-box">
        <div className="icon-wrapper">
          <InformationIcon />
        </div>
        <div className="information-wrapper">
          <div className="title">
            {`${t('product_models_context.upload_instructions')} `}
            <span>
              <a href={productModelsUploadInstructions} target="_blank" rel="noreferrer" className="external-link">
                {t('document_context.click_here')}
              </a>
            </span>
          </div>
        </div>
      </div>
      <WrappedTabs
        containerId="product-models-tabs"
        className="main-page-tabs-wrapper internal-tabs"
        tabs={productModelsPages.map((page) => ({ id: page.key, name: page.title }))}
        activeTab={selectedPage?.key}
        changeTab={handleTabClick}
      />
      {selectedPage?.content && selectedPage.content}
    </>
  )
}

function stateToProps({ productModels }) {
  return {
    filters: productModels?.productModelsFilterOptions || {},
    models: productModels?.productModelsFilterOptions?.models || [],
    modelCategory: productModels?.productModelsFilterOptions?.modelCategory || [],
    productTypes: productModels?.productModelsFilterOptions?.productTypes || [],
    productCategories: productModels?.productModelsFilterOptions?.productCategories || [],
    technologies: productModels?.productModelsFilterOptions?.technologies || [],
    brands: productModels?.productModelsFilterOptions?.brands || [],
    deviceFunctions: productModels?.productModelsFilterOptions?.deviceFunctions || [],
    adminProductTypes: productModels?.productTypes || [],
  }
}

function dispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadProductModelsFilterOptions,
        loadAdminProductTypes,
      },
      dispatch,
    ),
  }
}

export default connect(stateToProps, dispatchToProps)(ProductModels)

